<template>
  <section id="topbar">
    <div class="right">
      <div v-if="change_club" @click="changeClub" class="change_club">
        {{ !event.is_campus ? $t("change_club") : $t("change_participant") }}
      </div>
      <Language></Language>
      <div class="user">{{ user.email }}</div>
      <div v-if="show_actions" @click="logout()" id="logout" class="name">
        {{ $t("logout") }}
      </div>
    </div>
  </section>
</template>

<script>
import i18n from "@/i18n";
import Language from "@/components/ui/Language.vue";
import { Api } from "@/core/api.js";
const api = new Api();

export default {
  components: { Language },
  data() {
    return {};
  },
  methods: {
    logout() {
      var self = this;
      api.get("logout").then(function (data) {
        var event = self.$store.getters.getCurrentEvent();
        self.$store.commit("user/setAuthenticate", false);
        self.$store.commit("setOverlayVisible", false);
        self.$store.commit("setUserMenuVisible", false);
        var campus = self.$store.getters["getCampus"];
        // campus ? self.$router.replace( { name: 'campus_login' } ) : self.$router.replace( { name: 'login' } );
        self.$router.replace({
          name: "event_login",
          params: {
            event: self.$root.formatEventUrl(event.name, event.edition),
          },
        });
      });
    },

    changeClub() {
      var self = this;
      var event = self.$store.getters.getCurrentEvent();

      api
        .login({
          username: this.user.username,
          password: this.user.password,
          event: event.id,
          route: "/login",
        })
        .then(function (response) {
          if (response.status) {
            self.error_message = false;

            if (
              typeof response.data.sel_club !== "undefined" &&
              response.data.sel_club
            ) {
              self.$store.commit("user/setAuthenticateSelClub", response.data);
              self.$router.push({
                name: "sel_club",
                params: {
                  event: self.$root.formatEventUrl(event.name, event.edition),
                },
              });
            } else {
              self.$store.commit("user/setAuthenticate", response.data);
              localStorage.setItem("token", response.data.token);

              self.$store.dispatch("loadTablesRelationship").then(function () {
                if (self.campus) {
                  self.$store.commit("setCampus", true);
                }
                self.$router.push({
                  name: "home",
                  params: {
                    event: self.$root.formatEventUrl(event.name, event.edition),
                  },
                });
              });
            }
          } else {
            self.error_message = true;
          }
        });
    },
  },
  created() {},
  computed: {
    show_actions() {
      return this.$route.name != "sign-document";
    },
    
    user() {
      return this.$store.getters["user/getUser"];
    },

    team() {
      return this.$store.getters["team/getTeam"];
    },

    club() {
      return this.$store.getters["club/getClub"];
    },

    change_club() {
      var user = this.$store.getters["user/getUser"];

      return typeof user.sel_club !== "undefined" && user.sel_club;
    },

    event() {
      return this.$store.getters.getCurrentEvent();
    },
  },
};
</script>

<style lang="scss" scoped>
#topbar {
  height: 70px;
  overflow: hidden;
  width: 100%;
  right: 0;
  top: 0;
  padding: 10px 25px;
  z-index: $z-header;
  background-color: #fff;
  //   border-bottom: 1px solid #ddd;
  margin-left: 0;
  z-index: 22;
}

.right {
  @include display-flex();
  @include align-items();
  padding: 0 12px;
  @include justify-content(flex-end);
  height: 100%;
  position: relative;
  float: right;
  width: 50%;

  #logout {
    @include background(
      $image: img("logout.svg"),
      $size: 20px,
      $position: left 6px center
    );
    padding-left: 33px;
    float: right;
    font-size: 16px;
    cursor: pointer;
    margin-left: 15px;
  }
  .user {
    margin-left: 15px;
  }

  .change_club {
    @include background(
      $image: img("change.svg"),
      $size: 20px,
      $position: left 6px center
    );
    padding-left: 30px;
    margin-right: 10px;
    cursor: pointer;
  }
}

@include media(">phone", "<desktop") {
  #topbar {
    width: 100%;
    padding-left: 50px;
    display: none;
  }

  #left-menu.opened ~ #main-content #topbar {
    padding-left: 0;
    padding-right: 50px;
  }

  .right {
    @include border-radius(100%);
    position: fixed;
    bottom: 5px;
    right: 15px;
    padding: 0;
    width: 40px;
    height: 40px;
    background-color: $main-color;
  }
}
</style>
